import { LinkProps } from 'next/link';

import { TextLinkProps } from '@src/components/atoms/text-link/types';
import { CmsContent } from '@src/contexts/cms-content-context';
import { StringFields } from '@src/utils/types';

export type ContentWithLinkProps = (LinkProps | TextLinkProps) & {
  className?: string;
  contentKey: StringFields<CmsContent>;
};

export const isTextLinkProps = (props: LinkProps | TextLinkProps): props is TextLinkProps => 'onClick' in props;
